//Ambiente di development da mettere online
export const environment = {
  production: false,
  testing: false,
  stage: "",
};

export const api = {
  baseUrl: "https://api-isp.adpl.it",
  // baseUrl: "https://ckjmzfg0-3000.euw.devtunnels.ms",
  prefixAuthorization: "Bearer",
  endpoint: {
    login: "/auth/login",
    recovery: "/recovery-password",
    sendEmailRecovery: "/auth/send-email",
    me: "/user/me",
    changePassword: "/auth/change-password",
    refreshToken: "/auth/refresh",
    register: "/auth/register",
  },
};
